import { useState, useEffect } from 'react';
import { isMobile } from 'react-device-detect';
import { AiOutlineSearch } from 'react-icons/ai';
import { BsChevronDown } from 'react-icons/bs';
import { IoExitOutline } from 'react-icons/io5';
import ReactImageFallback from 'react-image-fallback';
import {
  CardHeader,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Input,
  UncontrolledDropdown,
} from 'reactstrap';
import companyFallback from '../../assets/images/company_fallback_img.jpg';
import darkLoader from '../../assets/images/dark_loader.gif';
import HomeButton from '../../components/homeButton/homeButton';
import { useDebounce } from '../../core/hooks/useDebounce';

const HeaderScreen = ({
  route,
  onLogout,
  data,
  selected,
  changeCompany,
  history,
  courseName,
  user,
}) => {
  const { location } = history;
  const [searchInput, setSearchInput] = useState('');
  const searchTerm = useDebounce(searchInput, 300);

  if (courseName) {
    return (
      <CardHeader className="card-header">
        <div style={{ flex: 1 }}>
          <h6 className="title">{courseName}</h6>
        </div>
        <div className="flex-header">
          <HomeButton routeBackName="/manual" />
        </div>
      </CardHeader>
    );
  }

  function sortByName(array) {
    return array?.slice?.()?.sort((a, b) => a?.name?.localeCompare(b?.name));
  }

  const filterCompanies = (companies) => {
    if (!searchTerm) return companies;
    return companies.filter((company) =>
      company.name?.toLowerCase().includes(searchTerm.toLowerCase())
    );
  };

  const isSuperAdmin = !!user?.isSuperAdmin;

  const renderContractBadge = (company) => {
    if (!isSuperAdmin || !company.contractStatus) return null;

    const { status, className, icon } = company.contractStatus;

    return (
      <span className={`contract-status-badge ${className}`}>
        <span className="status-icon">{icon}</span>
        <span>{status}</span>
      </span>
    );
  };

  if (route && route.hideHeader) return null;

  return location.pathname === '/home' ? (
    <CardHeader className="card-header card-header--home">
      <div style={{ flex: 1 }}>
        {route && route.title ? (
          <h6 className="title">{route.title}</h6>
        ) : (
          <div />
        )}
      </div>

      <div className="flex-header">
        {route && route.action ? route.action(history) : <div />}
        <UncontrolledDropdown className="btn-rotate">
          <DropdownToggle
            aria-haspopup={true}
            caret={false}
            color="#000"
            data-toggle="dropdown"
            // id="navbarDropdownMenuLink"
            nav
          >
            <div className="perfil main">
              <ReactImageFallback
                src={`${process.env.REACT_APP_SUPABASE_URL}/storage/v1/object/public/${selected.logo}`}
                fallbackImage={companyFallback}
                initialImage={darkLoader}
                alt=""
                className="perfil-logo"
              />
              {isMobile ? (
                <h6 className="perfil-text">{selected.name}</h6>
              ) : (
                <h6 className="perfil-text">{selected.name}</h6>
              )}
              <BsChevronDown className="perfil-icon" />
            </div>
          </DropdownToggle>
          <DropdownMenu
            style={{ maxHeight: 550, overflowY: 'auto', width: '350px' }}
            className="dropdown-menu-header"
            aria-labelledby="navbarDropdownMenuLink"
            right
          >
            <div className="company-search-container">
              <div className="search-input-wrapper">
                <AiOutlineSearch className="search-icon" />
                <Input
                  type="text"
                  placeholder="Buscar empresa..."
                  value={searchInput}
                  onChange={(e) => setSearchInput(e.target.value)}
                  className="company-search-input"
                  onClick={(e) => e.stopPropagation()}
                />
              </div>
            </div>
            <div className="companies-list">
              {filterCompanies(sortByName(data))
                .filter((item) => item.id !== selected.id)
                .map((item) => (
                  <DropdownItem
                    key={item?.id}
                    onClick={() => {
                      changeCompany(item);
                      setSearchInput('');
                    }}
                    className={'drop-item'}
                  >
                    <div className="company-item-wrapper">
                      <div className="perfil">
                        <ReactImageFallback
                          src={`${process.env.REACT_APP_SUPABASE_URL}/storage/v1/object/public/${item.logo}`}
                          fallbackImage={companyFallback}
                          initialImage={darkLoader}
                          alt=""
                          className="perfil-logo"
                        />
                        <h6 className="perfil-text">{item.name}</h6>
                      </div>
                      {renderContractBadge(item)}
                    </div>
                  </DropdownItem>
                ))}
              {filterCompanies(sortByName(data)).filter(
                (item) => item.id !== selected.id
              ).length === 0 && (
                <div className="no-results">
                  <p>Nenhuma empresa encontrada</p>
                </div>
              )}
            </div>
            {/* <DropdownItem
                    onClick={() => { }}
                    className={'drop-item'}
                >
                    <div className='perfil' >
                        <IoAddCircleOutline size={30} />
                        <h6 className='perfil-text'>Adicionar Empresa</h6>
                    </div>
                </DropdownItem> */}

            <DropdownItem onClick={onLogout} className={'drop-logout'}>
              <div className="perfil-logout">
                <IoExitOutline size={30} />
                <h6 className="perfil-text">Sair</h6>
              </div>
            </DropdownItem>
          </DropdownMenu>
        </UncontrolledDropdown>
      </div>
    </CardHeader>
  ) : (
    <CardHeader className="card-header">
      <div style={{ flex: 1 }}>
        {route && route.title ? (
          <h6 className="title">{route.title}</h6>
        ) : (
          <div />
        )}
      </div>
      <div className="flex-header">
        {route && route.action ? route.action(history) : <div />}
      </div>
    </CardHeader>
  );
};

export default HeaderScreen;
